/* global window, document, URL, Blob */

import * as R from 'ramda';

export default function ActivePmDocumentController(
  $q,
  $scope,
  $rootScope,

  alerts,
  pmBoardApproveDialog,
  confirmDialog,
  editPmDocumentDialog,
  generateDocumentDialog,
  loaderService,
  orgDataService,
  pmDataService,
  editDocumentAttachmentDialog,
  pmChangeLogDialog,
  ssDialogService,
  pmSharedModelService,
  syncRecommendedChangesDialog,
) {
  const vm = this;

  vm.isExpanded = false;
  vm.attachmentsLoaded = false;

  vm.handleEdit = _handleEdit;
  vm.handleSync = _handleSync;
  vm.handleDelete = _handleDelete;
  vm.handleGenerateDocument = _handleGenerateDocument;
  vm.handleBoardApprove = _handleBoardApprove;
  vm.handleShowChangeLog = _handleShowChangeLog;
  vm.handleExpandDocument = _handleExpandDocument;
  vm.handleAttachItems = _handleAttachItems;
  vm.handleDownloadAllForms = _handleDownloadAllForms;
  vm.handleDownloadAllAddenda = _handleDownloadAllAddenda;

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleGenerateDocument($event) {
    _showGenerateDocumentDialog($event);
  }

  function _handleBoardApprove($event) {
    return _showBoardApproveDialog($event);
  }

  function _handleShowChangeLog($event) {
    loaderService.showViewLoader = true;
    return pmDataService.getChangeLog(vm.document.policyDocumentId).then(
      // Success
      (getChangeLogResponse) => {
        loaderService.showViewLoader = false;
        return _showChangeLogDialog($event, {
          policyDocumentId: vm.document.policyDocumentId,
          changeLogItems: getChangeLogResponse.data.result,
          isNavantaUser: vm.isNavantaUser,
        });
      },
      // Failure
      () => {
        loaderService.showViewLoader = false;
        alerts.error('There was an error fetching the Change Log');
      }
    );
  }

  function _handleEdit($event) {
    loaderService.showViewLoader = true;
    return pmDataService.getPolicyDocument(
      vm.document.policyDocumentId
    ).then((getPolicyDocumentResponse) => {
      pmDataService.getSettings().then((settingsResponse) => {
        const settings = settingsResponse.data;
        loaderService.showViewLoader = false;
        return _showEditPmDocumentDialog($event, {
          document: getPolicyDocumentResponse.data,
          settings,
        });
      });
    });
  }

  function _handleSync($event) {
    loaderService.showViewLoader = true;
    
    return pmDataService.getCompareToMasterDocument(
      vm.document.policyDocumentId
    ).then((getCompareToMasterDocumentResponse) => {
      getCompareToMasterDocumentResponse.data.policyDocumentId = vm.document.policyDocumentId;
      
      pmSharedModelService.changedSections = getCompareToMasterDocumentResponse.data;

      const {
        addedMasterSectionIds,
        deletedSectionIds,
        updatedEndNoteIds,
        updatedSectionIds,
        updatedMasterSectionIds
      } = pmSharedModelService.changedSections;
      const combinedNewRecommendedChanges = [];
      if (addedMasterSectionIds && addedMasterSectionIds.length > 0) {
        combinedNewRecommendedChanges.push(...addedMasterSectionIds);
      }
      if (deletedSectionIds && deletedSectionIds.length > 0) {
        combinedNewRecommendedChanges.push(...deletedSectionIds);
      }
      if (updatedEndNoteIds && updatedEndNoteIds.length > 0) {
        combinedNewRecommendedChanges.push(...updatedEndNoteIds);
      }
      if (updatedSectionIds && updatedSectionIds.length > 0) {
        combinedNewRecommendedChanges.push(...updatedSectionIds);
      }
      if (updatedMasterSectionIds && updatedMasterSectionIds.length > 0) {
        combinedNewRecommendedChanges.push(...updatedMasterSectionIds);
      }

      _showNewRecommendedChangesDialog($event, {
        newChanges: combinedNewRecommendedChanges,
        changedIds: pmSharedModelService.changedSections,
        isNew: false,
        changesAreRecommended: false,
      });
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _showNewRecommendedChangesDialog($event, locals) {
    ssDialogService.dialogs.pm.syncRecommendedChangesDialog = ssDialogService.alert(
      syncRecommendedChangesDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.syncRecommendedChangesDialog);
  }

  function _handleDelete($event) {
    return _showConfirmDeletePolicyDocumentDialog($event);
  }

  function _handleDownloadAllForms() {
    loaderService.showViewLoader = true;
    pmDataService.downloadAllDocumentSupportingDocuments(vm.document.policyDocumentId).then((response) => {
      _handleDownload(response);
    });
  }

  function _handleDownloadAllAddenda() {
    loaderService.showViewLoader = true;
    pmDataService.downloadAllDocumentAddenda(vm.document.policyDocumentId).then((response) => {
      _handleDownload(response);
    });
  }

  function _handleDownload(response) {
    alerts.success('The file download will start momentarily.');
    const contentDisposition = response.headers('Content-Disposition');

    if (!R.isNil(contentDisposition)) {
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
      vm.downloadName = matches && matches.length > 1 ? matches[1] : null;
      vm.downloadName = vm.downloadName.split('"').join('');
    }

    const blob = new Blob(
      [response.data],
      { type: 'application/x-zip-compressed', }
    );

    // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, vm.downloadName);
    } else {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      anchor.setAttribute('type', 'hidden');

      anchor.href = URL.createObjectURL(blob);
      anchor.download = vm.downloadName;
      anchor.target = '_self';
      anchor.click();
    }

    loaderService.showViewLoader = false;
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on('setDocumentRegenerateFlag', () => {
      if (vm.document.policyDocumentId > 0) {
        vm.document.regenerateDocument = true;
      }
    });

    $scope.$on('refreshPMDocumentAttachments', (event, opt) => {
      if (opt.policyDocumentId === vm.document.policyDocumentId) {
        _refreshAttachments();
      }
    });
  }

  function _handleExpandDocument() {
    if (!vm.attachmentsLoaded) {
      _refreshAttachments().then(() => {
        vm.isExpanded = !vm.isExpanded;
      });
    } else {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _handleAttachItems($event) {
    ssDialogService.dialogs.pm.editDocumentAttachmentDialog = ssDialogService.alert(
      editDocumentAttachmentDialog.getOptions($event, {
        document: vm.document,
        attachment: {
          policyDocumentAttachmentId: 0,
          deletable: true,
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pm.editDocumentAttachmentDialog);
  }

  function _showEditPmDocumentDialog($event, locals) {
    ssDialogService.dialogs.pm.editPmDocumentDialog = ssDialogService.alert(
      editPmDocumentDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.editPmDocumentDialog);
  }

  // function _showSyncPmDocumentDialog($event, locals) {
  //   ssDialogService.dialogs.pm.syncPmDocumentDialog = ssDialogService.alert(
  //     syncPmDocumentDialog.getOptions($event, locals)
  //   );
  //   return ssDialogService.show(ssDialogService.dialogs.pm.syncPmDocumentDialog);
  // }

  function _showGenerateDocumentDialog($event) {
    ssDialogService.dialogs.pm.generateDocumentDialog = ssDialogService.alert(
      generateDocumentDialog.getOptions($event, {
        document: vm.document,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pm.generateDocumentDialog);
  }

  function _showBoardApproveDialog($event) {
    orgDataService.getSelectableUsers().then((response) => {
      ssDialogService.dialogs.pm.boardApproveDialog = ssDialogService.alert(
        pmBoardApproveDialog.getOptions($event, {
          policyDocumentId: vm.document.policyDocumentId,
          documentName: vm.document.name,
          isNavantaUser: vm.isNavantaUser,
          users: response.data.result,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.pm.boardApproveDialog);
    });
  }

  function _showConfirmDeletePolicyDocumentDialog($event) {
    ssDialogService.dialogs.pm.confirmDeletePolicyDocumentDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Policy Document?',
        message: `Are you sure you want to delete the Policy Document "${vm.document.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _closeDeleteDialog,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.confirmDeletePolicyDocumentDialog);
  }

  function _handleConfirmDelete($event) {
    return pmDataService.deletePolicyDocument(vm.document.policyDocumentId)
      .then(() => {
        alerts.success('The Policy Document has been deleted successfully.');
        $rootScope.$broadcast('activeDocumentDeleted', { policyDocumentId: vm.document.policyDocumentId });
        $rootScope.$broadcast('refreshPMDocuments');
        _closeDeleteDialog($event);
      }).catch(() => {
        alerts.error('An error occurred deleting the Policy Document.');
      });
  }

  // function _handleConfirmSync($event) {
  //   console.log($event);
  //   return pmDataService.syncPolicyDocumentToMaster(vm.document.policyDocumentId)
  //     .then(() => {
  //       alerts.success('The Policy Document has been synced successfully.');
  //       $rootScope.$broadcast('refreshPMDocuments');
  //       _closeDeleteDialog($event);
  //     }).catch(() => {
  //       alerts.error('An error occurred syncing the Policy Document.');
  //     });
  // }

  function _refreshAttachments() {
    loaderService.showViewLoader = true;
    return $q.all([
      pmDataService.getSupportingDocumentsByPolicyDocument(vm.document.policyDocumentId),
      pmDataService.getAddendaByPolicyDocument(vm.document.policyDocumentId),
    ]).then((responses) => {
      vm.attachmentsLoaded = true;
      vm.supportingDocuments = responses[0].data.result;
      vm.addenda = responses[1].data.result;
      loaderService.showViewLoader = false;
    });
  }

  function _showChangeLogDialog($event, locals) {
    ssDialogService.dialogs.pm.changeLogDialog = ssDialogService.alert(
      pmChangeLogDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.changeLogDialog);
  }

  // function _closeSyncDialog() {
  //   return ssDialogService.hide(ssDialogService.dialogs.pm.confirmSyncPolicyDocumentDialog);
  // }

  function _closeDeleteDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.confirmDeletePolicyDocumentDialog);
  }
}

ActivePmDocumentController.$inject = [
  '$q',
  '$scope',
  '$rootScope',

  'alerts',
  'pmBoardApproveDialog',
  'confirmDialog',
  'editPmDocumentDialog',
  'generateDocumentDialog',
  'loaderService',
  'orgDataService',
  'pmDataService',
  'editDocumentAttachmentDialog',
  'pmChangeLogDialog',
  'ssDialogService',
  'pmSharedModelService',
  'syncRecommendedChangesDialog',
];
